import React,{useState,useEffect} from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from '../../../../components/panelcontrols/paneltablebuttons/deletebutton'
import EditButton from '../../../../components/panelcontrols/paneltablebuttons/editbutton'
import Functions from '../functions'

const Index = ({List,setList,setSelectedEmployee,setShowEdit,toast}) => {
  const [filterList,setfilterList] = useState(List);
  function filterFunction(value){
    if(value === ""){
      setfilterList(List);
    }
    else{
      const filtedList = List.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setfilterList(filtedList);
    }
  }
  useEffect(()=>{
      setfilterList(List);
  },[List])
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input onChange={(e)=>{filterFunction(e.target.value);}}/>
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              <div className='_th' style={{width:"15%"}}>Name</div>
              <div className='_th' style={{width:"15%"}}>Designation</div>
              <div className='_th' style={{width:"10%"}}>Salary</div>
              <div className='_th' style={{width:"10%"}}>Status</div>
              <div className='_th' style={{width:"15%"}}>Contact</div>
              <div className='_th' style={{width:"15%"}}>Cnic</div>
              <div className='_th' style={{width:"20%"}}></div>
            </div>
          </div>
          <div className='_tbody'>
            {filterList.length > 0 &&
              filterList.map((item,index)=>{
                return(
                  <div className='_tr' key={index}>
                    <div className='_td' style={{width:"15%"}}>{item.name}</div>
                    <div className='_td' style={{width:"15%"}}>{item.designation}</div>
                    <div className='_td' style={{width:"10%"}}>{item.salary}</div>
                    <div className='_td' style={{width:"10%"}}>{item.status}</div>
                    <div className='_td' style={{width:"15%"}}>{item.contact}</div>
                    <div className='_td' style={{width:"15%"}}>{item.cnic}</div>
                    <div className='_td' style={{width:"20%",display:"flex", justifyContent:"space-evenly"}}>
                      <EditButton Action={()=>{
                        setSelectedEmployee(item);
                        setShowEdit(true);
                      }}/>
                      <DeleteButton Action={()=>{
                        const confermation = window.confirm('Are you sure you want to delete this doctor?');
                        if(!confermation){
                          return;
                        }
                        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                        Functions.Delete(item.id,setList,toast,toastid)
                      }}/>
                    </div>
                  </div>
                )
              })
            }
            {filterList.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>      
    </div>
  )
}

export default Index
